import { motion } from "framer-motion";
import { Fingerprint, Users, History } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const PILLARS = [
  {
    index: "01",
    Icon: Fingerprint,
    title: "One Football Identity",
    body: "Every player deserves a permanent profile that reflects their football journey.",
    testid: "pillar-identity",
  },
  {
    index: "02",
    Icon: Users,
    title: "Stronger Communities",
    body: "Helping players, football communities, clubs and academies connect and grow together.",
    testid: "pillar-communities",
  },
  {
    index: "03",
    Icon: History,
    title: "Every Match Preserved",
    body: "Recording matches, results and achievements so grassroots football history is never lost.",
    testid: "pillar-preserved",
  },
];

export default function BrandPillars() {
  return (
    <section
      id="collective"
      data-testid="brand-pillars"
      className="relative z-20 bg-[#0B0B0B] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-3 md:gap-12 lg:gap-20">
          {PILLARS.map((pillar, i) => {
            const { Icon } = pillar;
            return (
              <motion.div
                key={pillar.title}
                data-testid={pillar.testid}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: EASE, delay: i * 0.14 }}
                className="flex flex-col"
              >
                <span className="font-body text-sm tracking-[0.3em] text-[#1F7A4D]">
                  {pillar.index}
                </span>

                <Icon
                  size={34}
                  strokeWidth={1.25}
                  className="mt-8 text-white"
                  aria-hidden="true"
                />

                <h3 className="mt-8 font-display uppercase text-4xl md:text-5xl leading-[0.9] tracking-wide text-white">
                  {pillar.title}
                </h3>

                <p className="mt-5 max-w-[34ch] font-body text-base md:text-lg font-light leading-relaxed text-[#B3B3B3]">
                  {pillar.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
